import React, { Fragment } from "react";

import { useTranslation } from "react-i18next";
import { NavLink, useNavigate, useParams } from "react-router-dom";

import { TitleH4 } from "components/generic";
import { CardBlogDiv, PostBlogSection, BlogBackDiv, PostTitle, TitleH2Other, TitleH3Other } from "./styles";
import { BLOG_ROUTE } from "utils/constants";
import { ISeo } from "interfaces/intarfaces";
import { HeaderSEO } from "components/headerSEO";
import { IconBack } from "../../../../components/Icons/Back";
import { ContentDiv } from "components/containers";
import { NotFound } from "../../../../components/NotFound";
import { getBlogData } from "../../../../utils/getBlogData";
import styled from "styled-components/macro";
import { theme } from "styles/theme";

import { Tag, Space } from "antd";


import Britt from "../../../../assets/images/team/new/Britt.webp";
import Daan from "../../../../assets/images/team/new/Daan.webp";
import Maurits from "../../../../assets/images/team/new/Maurits.webp";
import Pavla from "../../../../assets/images/team/new/Pavla.webp";
import Joost from "../../../../assets/images/team/new/Joost.webp";
import Vera from "../../../../assets/images/team/new/Vera.webp";
import Vincent from "../../../../assets/images/team/new/Vincent.webp";
import Job from "../../../../assets/images/team/new/Job.webp";
import Flavia from "../../../../assets/images/team/new/Flavia.webp"

const ImageMap: {[key: string]: string} = {
  "Britt": Britt,
  "Daan": Daan,
  "Maurits": Maurits,
  "Pavla": Pavla,
  "Joost": Joost,
  "Vera": Vera,
  "Vincent": Vincent,
  "Job": Job,
  "Flavia": Flavia
};


const AuthDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.span`
  margin: 0.5em 0 0.5em 0 !important;
`

const Image = styled.img`
  margin-bottom:0.5em;
`
const AuthorInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5em;  // Provides a small gap between image and text, adjust as needed

  & > div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;  // Align text to the left

    & > strong {
      display: block;
    }

    & > small {
      display: block;
    }
  }
`;

const AuthorImage = styled.img`
  width: 30px;  // Adjust the image width as needed
  height: 30px; // Adjust the image height as needed
  border-radius: 50%;  // This makes the image rounded
  object-fit: cover;
`;


export const CardBlog: React.FC<{ keyPost: string; index: number }> = ({
  keyPost,
  index
}) => {
  const { t, i18n } = useTranslation(`blog/${keyPost}`);
  const navigate = useNavigate();

  function getAuthorImage(name: string) {
    return ImageMap[name] || undefined; // or provide a default image if you want
  }

  const tags: string[] = t("tags", { returnObjects: true });
  const authorImageName = t("author_image");
  const authorImageSrc = getAuthorImage(authorImageName);

  return (
    <CardBlogDiv
      onClick={() =>
        navigate(`/${i18n.language}${BLOG_ROUTE.slice(5)}/${keyPost}`)
      }
    >
      <Image
        src={
          (process.env.PUBLIC_URL as string) + "/images/" + t("images.0.name")
        }
        alt={t("images.0.alt")}
      />
      <Space size={[0, 'small']} wrap>
        {Array.isArray(tags) && tags.map((tag, index) => (
            <Tag
              key={index}
              bordered={false}
              style={{
                backgroundColor: theme.colors.blogTags,
                color: theme.colors.chatFadedTextColor,
                borderColor: theme.colors.blogTags,
                borderRadius: "50px"
              }}
            >{tag}</Tag>
        ))}
      </Space>
      <Title>{t("title")}</Title>
      <p>{t("shotInfo")}</p>
      <AuthDiv>
        <AuthorInfo>
          <AuthorImage src={authorImageSrc}  alt="Author's Name" />
          <div>
            <strong>{t("author")}</strong>  {/* This will make the author's name bold */}
            <small>{t("published_date")}</small>
          </div>
        </AuthorInfo>
      </AuthDiv>
    </CardBlogDiv>
  );
};

interface ImageData {
  name: string;
  alt: string;
  position: number;
}

export const PostBlog: React.FC = () => {
  // export const PostBlog: React.FC<PostBlogProps> = ({ index }) => {

  const { id } = useParams();
  const { t: t_main, i18n } = useTranslation("blog");
  const { t } = useTranslation(`blog/${id}`);

  const blogData = getBlogData(i18n.language);
  const postExists = blogData.some((item) => item.url === id);

  if (!postExists) {
    return <NotFound />;
  }

  const images: ImageData[] = t("images", { returnObjects: true });
  const labels: string[] = t("label", { returnObjects: true });
  const urlStrings: string[] = t("links", { returnObjects: true });
  const textLines: string[] = t("text", { returnObjects: true });

  const formattedTextLines = textLines.map((text) => {
    urlStrings.forEach((url, index) => {
      text = text.replace(new RegExp(`<${index}>`, 'g'), `<a href="${url}" target="_blank" style=" color:#EA6B26;">`);
      text = text.replace(new RegExp(`</${index}>`, 'g'), '</a>');
    });
    return text;
  });
  const seo = t("seo", { returnObjects: true }) as ISeo;
  return (
    <ContentDiv>
      {seo && <HeaderSEO {...seo} />}
      <PostBlogSection>
        <BlogBackDiv>
          <NavLink to={`/${i18n.language}${BLOG_ROUTE.slice(5)}`}>
            <>
              {IconBack}
              {t_main("blog.backToAll")}
            </>
          </NavLink>
        </BlogBackDiv>
        <PostTitle>{t("title")}</PostTitle>
        {formattedTextLines.length &&
          formattedTextLines.map((item, num) => (
            <Fragment key={num}>
              {images.findIndex((item) => item.position === num) !== -1 && (
                <div>
                  <img
                    src={
                      (process.env.PUBLIC_URL as string) +
                      "/images/" +
                      images[images.findIndex((item) => item.position === num)][
                      "name"
                      ]
                    }
                    alt={t(
                      images[images.findIndex((item) => item.position === num)][
                      "alt"
                      ]
                    )}
                  />
                  <TitleH4>{labels.shift()}</TitleH4>
                </div>
              )}

              {item.startsWith("<TitleH2>") ? (
                <TitleH2Other>
                  {/* Extract the text between '<TitleH2>' and '</TitleH2>' */}
                  {item.replace(/<\/?TitleH2>/g, "")}
                </TitleH2Other>
              ) : item.startsWith("<TitleH3>") ? (
                <TitleH3Other>
                  {/* Extract the text between '<TitleH3>' and '</TitleH3>' */}
                  {item.replace(/<\/?TitleH3>/g, "")}
                </TitleH3Other>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: item }} />
              )}
            </Fragment>
          ))}
      </PostBlogSection>
    </ContentDiv>
  );
};
